module.exports = __webpack_public_path__ + "static/media/astro.85bb5154.png";